import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { getBrowserName, isLoggedIn } from "config/utils";

// __________ paytm payment api  __________
export const generateMailOtp = async (data = {}) => {
  const token = isLoggedIn();
  return decryptData(
    await axios.post(`/send-verification-otp`, {
      reqData: encryptData({
        ...data,
                platformType: getBrowserName(),
        access_token: token,
      
      }),
    })
  );
};

export const verifyMailOtp = async (data = {}) => {
  const token = isLoggedIn();
  return decryptData(
    await axios.post(`/verify-verification-otp`, {
      reqData: encryptData({
        ...data,
                platformType: getBrowserName(),
        access_token: token,

      }),
    })
  );
};


export const resendMailOtp = async (data = {}) => {
  const token = isLoggedIn();
  return decryptData(
    await axios.post(`/resend-verification-otp`, {
      reqData: encryptData({
        ...data,
                platformType: getBrowserName(),
        access_token: token,

      }),
    })
  );
};

// for qr code taking access token from data...
export const QRcodeChecksum = async (data = {}) => {
  return decryptData(
    await axios.post(`/icici-checksum`, {
      reqData: encryptData({
        ...data,
        platformType: getBrowserName(),
      }),
    })
  );
};

export const getQrCourseDetails= async (data = {}) => {
  return decryptData(
    await axios.get(
      `/get-qr-course-details?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),

      })}`
    )
  );
};
